import { SkeletonBox } from '@practium/ui';
import styles from './StatCard.module.css';

export const StatCardSkeleton = () => (
	<div className={styles.card}>
		<div className={styles.content}>
			<div className={styles.textGroup}>
				<SkeletonBox width="3.5rem" height="1.25rem" />
				<SkeletonBox width="8rem" height="0.875rem" style={{ marginTop: '0.5rem' }} />
			</div>
			<SkeletonBox width="7rem" height="0.7rem" />
		</div>
		<div className={styles.iconContainer}>
			<SkeletonBox width="1.5rem" height="1.5rem" borderRadius="0.375rem" />
		</div>
	</div>
);
